import React from 'react'
import List from '../../crud/list'
import menuItems from './menuItems'

const columns = [
  {
    title: 'IPED #',
    prop: 'iped_code'
  },
  {
    title: 'Name',
    prop: 'name'
  }
]

const filters = [
  {
    name: 'Filter by name',
    prop: 'filters.name_ilike',
    type: 'text',
    enabled: true
  }
]

const defaults = {
  order: [{ column: 'name', direction: 'asc' }]
}

const Universities = props => {
  return (
    <List
      title='Universities'
      apiPath='admin/universities'
      columns={columns}
      filters={filters}
      defaults={defaults}
      buildMenuItems={menuItems}
      locationPathname={props.location.pathname}
      locationSearch={props.location.search}
    />
  )
}

export default Universities
